// @flow

// history actions are mainly intended for the corresponding history reducer,
// meant to track a user's navigation through a tab/window. The location, built
// by React Router although not neccessarily bound to it, describes a URL and
// any history state attached to it as well as the action (PUSH, POP, or
// REPLACE) that created the entry.
//
// history was created to replace the location actions/reducer as a cleaner
// and more powerful API.
//
// TODO: Remove previousRoutePath once the location reducer is removed.

export type HistoryAction = 'PUSH' | 'REPLACE' | 'POP';

export type HistoryLocation = {|
  pathname: string,
  hash?: string,
  search?: string,
  query?: { [key: string]: string | Array<String> },
  state?: ?{ [key: string]: any },
|};

export type RouteChangeAction = {|
  type: 'ROUTE_CHANGE',
  payload: {
    action: HistoryAction,
    location: HistoryLocation,
    routePath: string,

    // Once we remove the Location reducer, we can remove this:
    previousRoutePath: string,
  },
|};

export function routeChange(
  action: HistoryAction,
  location: HistoryLocation,
  routePath: string = '',
  previousRoutePath: string = '',
): RouteChangeAction {
  return {
    type: 'ROUTE_CHANGE',
    payload: {
      action,
      location,
      routePath,
      previousRoutePath,
    },
  };
}

export type RouteEnterAction = {|
  type: 'ROUTE_ENTER',
  payload: {
    location: HistoryLocation,
    routePath: string,

    // Once we remove the Location reducer, we can remove these:
    action: 'POP',
    previousRoutePath: '',
  },
|};

export function routeEnter(location: HistoryLocation, routePath: string = ''): RouteEnterAction {
  return {
    type: 'ROUTE_ENTER',
    payload: {
      action: 'POP',
      location,
      routePath,
      previousRoutePath: '',
    },
  };
}
